<template>
  <div>
    <Menu v-show="menu"></Menu>
    <v-form v-show="showDtlEdit" v-model="isValid">
      <h1>{{ mbr.fullName }}</h1>
      <v-row class=compact dense>
        <v-col cols="12" sm="6">
          <v-container class="compact" dense>
            <v-row dense>
              <v-col cols="12" sm="4">
                <v-text-field v-model="mbr.mNbr" label="M Nbr" :disabled="!mayEditRoles"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="mbr.firstName" label="Forename"
                              :rules="[v => !!v || 'Forename is required']"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="mbr.surName" label="Surname"
                              :rules="[v => !!v || 'Surname is required']"></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="8">
                <v-text-field v-model="mbr.email" label="email"
                              required
                              hint="Email"
                              :rules="[
                                  v => !!v || 'Email is required',
                                  v => /.+@.+\.+[A-Za-z0-9\-]+/.test(v) || 'E-mail must be valid'
                                  ]">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="mbr.phone" label="Phone"
                              :rules="[v => !!v || 'Phone is required']"></v-text-field>
              </v-col>
            </v-row>
            <v-row>

              <v-col cols="12" sm="12">
                <v-text-field v-model="mbr.street" label="Street" :rules="[
                      v => !!v || 'Street address is required',
                      v => (v && v.length >= 3) || 'Street address must have 3+ characters'
                      ]"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field v-model="mbr.city" label="City / Locality" :rules="[
                      v => !!v || 'City / locality is required',
                      v => (v && v.length >= 3) || 'City / locality must have 3+ characters'
                    ]"></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-select v-model="mbr.state" :items="this.$itmStore.states" label="State" :rules="[
                      v => !!v || 'State is required',
                      v => (v && v.length >= 2) || 'State must have 2+ characters'
                    ]"></v-select>
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field v-model="mbr.postalCode" label="Postal" :rules="[
                      v => !!v || 'Postal code is required',
                      v => (v && v.length >= 4) || 'Postal code must have 4+ characters'
                    ]"></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field v-model="mbr.country" label="Country"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="3" v-show="mayEditRoles">
                <DateField :rcvd-date="mbr.memberSince" :itm-key="mbr.mNbr" @datechanged="memSince" lbl="Joined"
                           :disabled="!mayEditRoles">
                </DateField>
              </v-col>
              <v-col cols="12" sm="3" v-show="mayEditRoles">
                <DateField :rcvd-date="mbr.renewedThru" :itm-key="mbr.mNbr" @datechanged="renDate" lbl="Renewal Due"
                           :disabled="!mayEditRoles">
                </DateField>
              </v-col>
              <v-col cols="12" sm="3" v-show="!mayEditRoles">
                <v-text-field v-model="mbrSince" label="Joined" :disabled="true"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" v-show="!mayEditRoles">
                <v-text-field v-model="expdt" label="Renewed" :disabled="true"></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-checkbox v-model="mbr.liabilityAgreement" label="Agrmnt" :disabled="!mayEditRoles"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="2">
                <v-checkbox v-model="mbr.firstAidQual" label="F aid"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="2">
                <v-select v-model="mbr.category" :items="['M','X']" label="Category"
                          :disabled="!mayEditRoles"></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-card
                    class="mx-auto"
                    max-width="300"
                    tile
                    align="left"
                    v-show="showRoles"
                >
                  <v-list dense>
                    <v-subheader>Roles</v-subheader>
                    <v-list-item
                        v-for="(role, i) in mbr.roles"
                        :key="i"
                    >
                      <v-list-item-icon v-on:click="removeRole(role)" v-show="mayEditRoles">
                        <v-icon v-text="icons.trash"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title v-text="role.roleName"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" v-show="mayEditRoles">
                <v-card
                    class="mx-auto"
                    max-width="300"
                    tile
                    align="left"
                    v-on:click="fillRoles()"
                >
                  <v-list dense>
                    <v-subheader>Roles</v-subheader>
                    <v-list-item
                        v-for="(role, i) in allRoles"
                        :key="i"
                    >
                      <v-list-item-icon v-on:click="addRole(role)" v-show="mayEditRoles">
                        <v-icon v-text="icons.plus"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title v-text="role.roleName"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-btn v-show="mayEditRoles" color="blue darken-1" text @click="close">Close</v-btn>
              <v-btn color="blue darken-1" :disabled="!isValid" text @click="save">Save Member data</v-btn>
            </v-row>
          </v-container>
        </v-col>
        <v-col sm="6">
          <div v-show="inactive">
            <h2>This is a inactive member</h2>
            <p>You can activate the member using the button below</p>
            <v-btn
                color="primary"
                v-show="!addDogPending"
                dark
                class="mb-2"
                @click="reactivate"
            >Reactivate
            </v-btn>
          </div>
          <div v-show="pending">
            <h2>Membership pending</h2>
            <p>Awaiting response from payment system</p>
          </div>
          <div v-for="dog in mbr.dogs" :key="dog.kNbr">
            <dog-detail :dog="dog" :mbr="mbr" @dogAdded="isAddDogPending"></dog-detail>
          </div>
          <a :href="this.$remote+'/w3/newdog?m='+this.mbr.id">Click here to add one or more dogs</a>
          <v-btn
              color="primary"
              v-show="!addDogPending&&false"
              dark
              class="mb-2"
              @click="addDog"
          >Add Dog
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import DogDetail from './DogDetail'
import DateField from './DateField'
import Menu from '@/components/Menu.vue'

export default {
  name: "MbrEdit2",
  components: {
    DogDetail,
    Menu,
    DateField
  },
  props: {
    mbr: {
      type: Object,
      default: () => {
      }
    },
    menu: {
      type: Boolean,
      default: false
    },
    mem: {
      Number,
      default: 0
    },
    mayEdmNbr: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    // whenever question changes, this function will run
    mbr: function (newMbr) {
      console.log('mbr changed')
      this.savedMbr = JSON.stringify(newMbr, 3)
    }
  },
  methods: {
    renDate: function (event) {
      console.log(event)
      this.mbr.renewedThru = event
    },
    memSince: function (event) {
      console.log(event)
      this.mbr.memberSince = event
    },
    close: function () {
      console.log(this.mbr)
      //this.mbr = JSON.parse(this.savedMbr)
      if (this.savedMbr) {
        this.$emit('endFullEdit', JSON.parse(this.savedMbr))
      } else {
        this.$emit('endFullEdit', null)
      }
    },
    fillRoles: function () {
      this.gLoadRoles()
      this.allRoles = this.$itmStore.roles
    },
    makeDog: function () {
      let dog = {
        kNbr: null,
        breed: null,
        callName: null,
        MemberId: this.mbr.mbrId,
        active: true,
        deceased: false,
        dob: null,
        dogReactive: false,
        gender: 'U',
        humanReactive: false,
        microchip: null,
        note: '',
        picture: null,
        reactiveParking: false,
        registeredName: null,
        rescue: false,
        xBreeds: null,
        Member: {
          mbrId: this.mbr.mbrId,
        },

      }
      this.addDogPending = true
      this.mbr.dogs.push(dog)
      return dog
    },
    isAddDogPending: function () {
      if (this.mbr.dogs !== 'undefined') {
        for (let idx = this.mbr.dogs.length - 1; idx >= 0; idx--) {
          if (this.mbr.dogs[idx].id == null) {
            this.addDogPending = true
          }
        }
      }
      this.addDogPending = false
    },
    save: function () {
      this.$http.post(this.$remote + '/api/modmbr', {mbr: this.mbr, token: this.$usrStore.token})
          .then(response => {
            this.$usrStore.token = response.data.token
            console.log(response)
          })
      this.$emit('endFullEdit', this.mbr)
    },
    save1: function () {
      this.$emit('endFullEdit', this.mbr)
    },
    removeRole: function (role) {
      if (confirm('Please confirm that you want to remove the ' + role.roleName + ' role from this member')) {
        let idx = this.mbr.roles.indexOf(role)
        if (idx > -1) {
          this.mbr.roles.splice(idx, 1)
          console.log('Removed ' + role.roleName)
        }
      }
    },
    addRole: function (role) {

      let idx = this.mbr.roles.indexOf(role)
      if (idx < 0) {
        this.mbr.roles.push(role)
        console.log('Added ' + role.roleName)
      }
    },
    toggleRole: function (role) {
      for (let i = 0; i < this.mbrRoles.length; i++) {
        if (this.mbrRoles[i].id === role.id) {
          this.mbrRoles.splice(i, 1);
          return true;
        }
      }
      this.selectedProducts.push(role);
    },
    isSelected: function (role) {
      for (let i = 0; i < this.mbrRoles.length; i++) {
        if (this.mbrRoles[i].id === role.id) {
          return true;
        }
      }
      return false;
    },
    addDog: function () {
      return this.makeDog()
    },
    reactivate: function () {
      //this.editingDog = true
      this.mbr.active = true
      alert('You have marked this member as active.\nTo make that permanent, please press SAVE')
    },

    toggleEditOff: function () {
      this.editingDog = false
    },
    closeDialog: function () {
      this.dialog = false
    }
  },
  mounted: function () {
    console.log('MbrEdit2 mounted')
    this.allRoles = this.$itmStore.roles
    console.log(this.allRoles)
  },
  created: function () {
    console.log('MbrEdit2 created')
    this.allRoles = this.$itmStore.roles
    console.log(this.allRoles)
  },
  computed: {
    inactive() {
      return (this.mbr!=null && !this.mbr.active && this.$isTokenCurrent() && this.mayEditRoles)
    },
    pending() {
      return (this.mbr!=null && this.mbr.mNbr==null && this.$isTokenCurrent())
    },
    mbrSince() {
      return this.$iso2AU(this.mbr.memberSince)

    },
    expdt() {
      return this.$iso2AU(this.mbr.renewedThru)
    },
    hasRole: {
      get(role) {
        return (role in this.mbr.roles) || true
      },
      set(role) {
        console.log(role)
      }
    },
    mayEditRoles() {
      return this.$hasRole(['adm', 'sys']) && this.mayEdmNbr
    },
    showRoles() {
      if (this.$hasRole(['adm', 'sys']))
        return true
      return (this.mbr.roles && this.mbr.roles.length > 0)
    },
    showDtlEdit() {
      return !this.editingDog
    },
  },
  data: () => ({
    spacer: ' ',
    icons: {trash: 'mdi-trash-can', plus: 'mdi-plus-thick'},
    rl: {'adm': true, 'Host': true, 'sys': true, 'Judge': true, 'CO': true},
    allRoles: [],
    mbrRoles: [],
    savedMbr: '',
    dialog: false,
    isValid: true,
    renewed: 'Renewal Due',
    heading: 'Member Detail',
    editingDog: false,
    currDog: {},
    addDogPending: false,
    //new_dog_url: this.$remote+'/w3/newdog?m='+this.mbr.mbrId
  })

}
</script>

<style scoped>
.compact {
  padding-top: 0px;
  margin-top: 0px;
}
</style>
